module.exports = __webpack_public_path__ + "img/Plus-icon.b1560356.svg";